import { DynamicStyleSheet } from '@pulsar/core';
import { Platform } from 'src/libs/platform';

export default DynamicStyleSheet.create(theme => ({
  root: {
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
    ...Platform.select({
      ios: {
        height: 44,
        minWidth: 44,
        paddingHorizontal: 8,
      },
      default: {
        height: 48,
        minWidth: 48,
        paddingHorizontal: 12,
        // to avoid sharp angles
        borderRadius: 2,
      },
    }),
  },
  content: {
    position: 'relative',
  },
  color: {
    color: theme.colors.headerControl,
    fontWeight: '600',
    fontSize: theme.fontSizes[2],
  },
  label: {
    position: 'absolute',
    top: -7,
    right: -6,
  },
}));
